class Config {
  isDevelopment = false;

  microfrontends = {
    audienceui: null,
    campaignsui: null,
    dashboardui: null,
    eventtrackingui: null,
    integrationsui: null,
    experienceui: null,
    reportdashboardui: null,
    usermanagementui: null,
    reportingui: null,
    reportinguiv2: null,
  };

  microservices = {
    auth: null,
    client: null,
    identity: null,
    webcontent: null,
    webcontentvue: null,
  };

  constructor() {
    this.isDevelopment = process.env.NODE_ENV === 'development';

    this.microfrontends = {
      audienceui: Config.getRequiredArg('VUE_APP_DYNAMICS_AUDIENCEUI'),
      campaignsui: Config.getRequiredArg('VUE_APP_DYNAMICS_CAMPAIGNSUI'),
      dashboardui: Config.getRequiredArg('VUE_APP_DYNAMICS_DASHBOARDUI'),
      eventtrackingui: Config.getRequiredArg('VUE_APP_DYNAMICS_EVENTTRACKINGUI'),
      integrationsui: Config.getRequiredArg('VUE_APP_DYNAMICS_INTEGRATIONSUI'),
      experienceui: Config.getRequiredArg('VUE_APP_DYNAMICS_EXPERIENCEUI'),
      reportdashboardui: Config.getRequiredArg('VUE_APP_DYNAMICS_REPORTDASHBOARDUI'),
      usermanagementui: Config.getRequiredArg('VUE_APP_DYNAMICS_USERMANAGEMENTUI'),
      reportingui: Config.getRequiredArg('VUE_APP_DYNAMICS_REPORTINGUI'),
      reportinguiv2: Config.getRequiredArg('VUE_APP_DYNAMICS_REPORTINGUIV2'),
    };

    this.microservices = {
      auth: Config.getRequiredArg('VUE_APP_DYNAMICS_AUTH'),
      client: Config.getRequiredArg('VUE_APP_DYNAMICS_CLIENT'),
      identity: Config.getRequiredArg('VUE_APP_DYNAMICS_IDENTITY'),
      webcontent: Config.getRequiredArg('VUE_APP_DYNAMICS_WEBCONTENT'),
      webcontentvue: Config.getRequiredArg('VUE_APP_DYNAMICS_WEBCONTENTVUE'),
    };
  }

  static getRequiredArg(name) {
    const value = process.env[name];
    if (!value) {
      throw new Error(`Config parameter '${name}' required`);
    }
    return value;
  }
}

export default new Config();
